export const ACCEPTED_EXTENSIONS = ['pdf', 'doc', 'docx', 'odt', 'txt', 'rtf'];
export const ACCEPTED_EXTENSIONS_ERROR = 'Resume file type must be .pdf, .doc, .docx, .odt, .txt, or .rtf';

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 mb
export const FILE_TOO_BIG_ERROR = 'Please upload a resume file that is smaller than 10 MB';

export const ACCEPTED_TYPES = [
  'application/msword',
  'application/pdf',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/rtf',
  // windows looks at file extension, so add the accepted extensions with a dot
  ...ACCEPTED_EXTENSIONS.map((ext) => (`.${ext}`)),
];

export const API_URL = '/api/profile/resume';
